import * as types from 'src/localization/types';

export const localized = (env: types.Env) => ({
  title: env.localizer('views.ConnectionGuideCorporateInstitution.title'),
  breadcrumbs: {
    institutions: env.localizer('views.InstitutionsOverview.title'),
    current: env.localizer('views.ConnectionGuideCorporateInstitution.title')
  }
});
